import { Button } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { Form, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import RefinePriceFormFields from './refine-price-form-fields';
import selectExcessToggleValues from '../../../selectors/select-excess-toggle-values';

type RefinePriceFormProps = {
  captureFormState: {
    // @ts-expect-error - Automatic, Please fix when editing this file
    setFormikErrors: (errors) => void;
    // @ts-expect-error - Automatic, Please fix when editing this file
    setFormikTouched: (touched) => void;
  };
  handleChangeProductType: Function;
  hasSubmitAttempt: boolean;
};

const RefinePriceForm = ({ captureFormState, handleChangeProductType, hasSubmitAttempt }: RefinePriceFormProps) => {
  const { errors, handleSubmit, touched } = useFormikContext();
  const setFormikTouched = captureFormState?.setFormikTouched;
  const setFormikErrors = captureFormState?.setFormikErrors;

  // ErrorSummary component requires formik context values. This allows us to pass the errors and touched objects outside the LeadCaptureForm
  useEffect(() => {
    if (setFormikErrors) {
      setFormikErrors(errors);
    }
  }, [errors, setFormikErrors]);

  useEffect(() => {
    if (setFormikTouched) {
      setFormikTouched(touched);
    }
  }, [touched, setFormikTouched]);

  return (
    <Form onSubmit={handleSubmit}>
      <RefinePriceFormFields handleChangeProductType={handleChangeProductType} hasSubmitAttempt={hasSubmitAttempt} />

      <Button
        icon={{
          name: 'arrow-right-long',
          position: 'right',
          size: 'large',
        }}
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: string; icon: { name: string; position: string; size: string; }; onClick: (e?: FormEvent<HTMLFormElement> | undefined) => void; type: string; variant: string[]; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'.
        onClick={handleSubmit}
        type="submit"
        variant={['flair', 'wide']}
      >
        Find Cover
      </Button>
    </Form>
  );
};

const mapStateToProps = (state: any) => ({
  hospitalExcess: selectExcessToggleValues(state),
  location: state?.router?.location,
});

export default connect(mapStateToProps)(RefinePriceForm);
